export default function ZoomitImageLoader({ src, width, quality }) {
  const params = new URLSearchParams({ w: Math.min(width, 1920), q: quality || 75 });
  return `${src}?${params}`;
}
